const translations = {
  "en": {
    "Send Ed a screenshot": "Send Ed a screenshot"
  },
  "zh-tw": {
    "Send Ed a screenshot": "傳送截圖給 Ed"
  }
};

export default translations;
